import { StaticImage } from "gatsby-plugin-image"
import LocalizedLink from "components/LocalizedLink"
import { useContext } from "react"
import { LocaleContext } from "contexts"
import useTranslations from "hooks/useTranslations"

export default function Report2025ReferenceSection() {
  const { locale } = useContext(LocaleContext)
  const {
    report2025HomepageSectionTitle,
    report2025HomepageSectionDescription,
    report2025HomepageSectionCta,
  } = useTranslations()

  return (
    <section className="relative bg-white py-16 lg:py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-12 lg:px-8">
        <div className="order-2">
          <h2 className="whitespace-pre-line text-3xl font-extrabold leading-tight tracking-tight text-zinc-900 sm:text-4xl">
            {report2025HomepageSectionTitle}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-zinc-700">
            {report2025HomepageSectionDescription}
          </p>
          <div className="mt-8">
            <LocalizedLink
              to="/schools/annual-reports/"
              className="inline-flex items-center rounded-xl bg-kkm-green px-6 py-3 text-base font-semibold text-zinc-900 transition hover:bg-kkm-green/90 focus:outline-none focus:ring-2 focus:ring-zinc-900/30 focus:ring-offset-2 focus:ring-offset-white"
            >
              {report2025HomepageSectionCta}
            </LocalizedLink>
          </div>
        </div>
        <div className="order-1 overflow-hidden rounded-2xl ring-1 ring-zinc-200">
          {locale.startsWith("sv") ? (
            <StaticImage
              src="../../../images/annual-reports/blog-sv.jpg"
              alt=""
              placeholder="blurred"
              className="!h-full !w-full"
              imgClassName="h-full w-full object-cover"
            />
          ) : null}
          {locale.startsWith("en") ? (
            <StaticImage
              src="../../../images/annual-reports/blog-en.jpg"
              alt=""
              placeholder="blurred"
              className="!h-full !w-full"
              imgClassName="h-full w-full object-cover"
            />
          ) : null}
          {!locale.startsWith("sv") && !locale.startsWith("en") ? (
            <StaticImage
              src="../../../images/annual-reports/blog-fi.jpg"
              alt=""
              placeholder="blurred"
              className="!h-full !w-full"
              imgClassName="h-full w-full object-cover"
            />
          ) : null}
        </div>
      </div>
    </section>
  )
}
